import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { LogOut } from 'lucide-react';
import { getDoc, doc } from 'firebase/firestore';
import { useTheme } from '../contexts/ThemeContext';

function ClientLayout({ children, db }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [programName, setProgramName] = useState('AgenTime');
  const [organizationName, setOrganizationName] = useState('');
  const { theme } = useTheme();

  const fetchApplicationSettings = useCallback(async () => {
    if (!db) return;
    try {
      const settingsDoc = await getDoc(doc(db, 'settings', 'general'));
      if (settingsDoc.exists()) {
        const settings = settingsDoc.data();
        if (settings.organizationName) {
          setOrganizationName(settings.organizationName);
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres:", error);
    }
  }, [db]);

  useEffect(() => {
    fetchApplicationSettings();
  }, [fetchApplicationSettings]);

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      navigate('/client-login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      {/* Container principal sans contraintes pour permettre le layout sidebar/main */}
      <main className="w-full">
        {children}
      </main>
    </div>
  );
}

export default ClientLayout;
